function retryify<P extends Array<any>, R>(fn: (...props: P) => Promise<R>, times = 1) {
  let count = 0;

  const wrapped = (...props: P): Promise<R> => {
    return fn(...props).catch((err) => {
      if (count >= times) {
        return Promise.reject(err);
      }

      count += 1;

      return wrapped(...props);
    });
  };

  return wrapped;
}

export default retryify;
